export default __webpack_public_path__ + "static/media/Tasset of the Tireless Defender.b27cd6b5.jpg";